module.exports = __webpack_public_path__ + "static/img/bg-tr.9432414d.png";